import * as ContainerUtils from '../container/container-utils';
import * as StateManager from '../store/state/state-manager';
import StateMachineManager from '../page-instructions/state-machine-manager';
import { FIELD_CHANGE, SET_PROPERTY } from '../store/state/actions/index';

/**
 * @description
 * Exposes APIs to update handling agentic ui updates.
 */
class AgentMessageHandler {
  /**
   * Update redux properties
   * @private
   */
  static transformReference(key: string): string {
    return key.replace(/^[^.]*\./, 'caseInfo.content.');
  }

  /**
   * Update redux properties
   * @private
   */
  static extractReferenceParts(reference: string): {
    pageReference: string;
    propertyName: string;
  } {
    const segments = reference.split('.');
    const propertyName = segments.pop() || '';
    const pageReference = segments.join('.');
    return { pageReference, propertyName };
  }

  /**
   * Update redux properties
   * @private
   */
  static publishCaseValuesUpdate(
    data: { message: { [key: string]: unknown } },
    dispatchData: { actionInContext: string }
  ) {
    const contextPath = `${dispatchData.actionInContext}/workarea`;
    Object.entries(data.message).forEach(([originalKey, value]) => {
      const context = ContainerUtils.getActiveContainerItemContext(contextPath) || '';

      const reference = this.transformReference(originalKey);
      const { pageReference, propertyName } = this.extractReferenceParts(reference);

      if (originalKey.match(/\.\w+\[\d+\]\.\w+/)) {
        StateMachineManager.executeStateMachine(context, reference, value, true, {
          skipStateUpdate: true
        });
      }
      const actions = [
        {
          type: SET_PROPERTY,
          payload: { reference, value, context }
        },
        {
          type: FIELD_CHANGE,
          payload: { reference, value, context, pageReference, propertyName }
        }
      ];

      StateManager.dispatch(actions);
    });
  }
}

export default AgentMessageHandler;
